import { create } from "@/api/rest";

const volunteeringCheckpoint = {
  create: async (data) => await create('/volunteering-checkpoint', data),
};

export default volunteeringCheckpoint;